import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const overlapCopies = (overlap) => {
    switch (overlap) {
    case 'same_start':
        return {
            confirmButton: 'Override Event',
            message: 'This event will override your existing event at the same time. Are you sure you want to continue?'
        };
    case 'after_start_after_end':
    case 'after_start_before_end':
        return {
            confirmButton: 'Play After',
            message: 'This event conflicts with an existing event. It will play upon completion of the existing event if you click on Play After.'
        };
    case 'before_start_before_end':
        return {
            confirmButton: 'Play First',
            message: 'This event conflicts with an existing event and will take priority on playback if you click Play First.'
        };
    case 'before_start_after_end':
        return {
            confirmButton: 'Ok, continue',
            message: 'This event conflicts with an existing event and will take priority on playback. Are you sure you want to continue?'
        };
    default:
        return {
            confirmButton: 'Ok',
            message: 'This event conflicts with an existing event.'
        };
    }
};

export default function OverlapModal ({ dialogOkAction, dialogIsOpen, closeDialog, overlap }) {
    const messages = overlapCopies(overlap);

    return (
        <Dialog
          color='primary'
          open={dialogIsOpen}
          onClose={closeDialog}>
            <DialogTitle color='primary'>
                Conflicting events
            </DialogTitle>
            <DialogContent color='tertiary'>
                <DialogContentText color='tertiary'>{messages.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>Cancel</Button>
                <Button onClick={dialogOkAction}>{messages.confirmButton}</Button>
            </DialogActions>
        </Dialog>
    );
}
